import { useUserInfoStore } from "@/stores/userInfo";
import { Form, Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";

export const useLogic = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userInfo] = useUserInfoStore()((state) => [
    state.userInfo,
    state.setUserInfo,
  ]);
  const submit = async () => {
    const values = form.getFieldsValue();
    if (
      !values.content ||
      !values.title ||
      values.content.length === 0 ||
      values.title.length === 0
    ) {
      return Toast.show("标题或内容不能为空！");
    }

    if (values.content.length < 20) {
      return Toast.show("内容不能少于20个字！");
    }
    Toast.show("反馈成功");
    navigate(-1);
  };
  return {
    userInfo,
    form,
    submit,
  };
};
